import React, { useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { stripePromise } from 'lib/payments';
import { PageProps } from 'types/page';
import { useTheme } from '@mui/material/styles';
import type { StripeElementsOptions } from '@stripe/stripe-js';
import withLayout from 'hocs/withLayout';
import Campaign from './Campaign';

/**
 * CampaignWithPayments – wraps Campaign with Stripe Elements for payment.
 * Route: /campaign
 */
const CampaignWithPayments = (props: PageProps) => {
  const theme = useTheme();

  const elementsOptions = useMemo((): StripeElementsOptions => {
    const isDark = theme.palette.mode === 'dark';
    return {
      appearance: {
        theme: isDark ? 'night' : 'stripe',
        variables: {
          colorPrimary: isDark ? '#ffffff' : '#0570de',
          colorBackground: isDark ? '#1e1e1e' : '#ffffff',
          colorText: isDark ? '#e3e3e3' : '#30313d',
          colorDanger: theme.palette.error.main,
          fontFamily: 'Roboto, sans-serif',
          borderRadius: '5px',
          spacingUnit: '4px',
        },
      },
    };
  }, [theme.palette.mode, theme.palette.error.main]);

  return (
    <Elements stripe={stripePromise} options={elementsOptions}>
      <Campaign {...props} />
    </Elements>
  );
};

export default withLayout(CampaignWithPayments, {
  contentWidth: 'sm',
});
